import { render, staticRenderFns } from "./DocumentsOrder.vue?vue&type=template&id=18d69370&"
import script from "./DocumentsOrder.vue?vue&type=script&lang=js&"
export * from "./DocumentsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports